import { render } from "./user_master.vue?vue&type=template&id=64a9e52e&scoped=true"
import script from "./user_master.vue?vue&type=script&lang=js"
export * from "./user_master.vue?vue&type=script&lang=js"

import "./user_master.vue?vue&type=style&index=0&id=64a9e52e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a9e52e"]])

export default __exports__